import { render, staticRenderFns } from "./FormPassword.vue?vue&type=template&id=51f8bdc0&scoped=true&"
var script = {}
import style0 from "./FormPassword.vue?vue&type=style&index=0&id=51f8bdc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8bdc0",
  null
  
)

export default component.exports